module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/al-090568ab89f9b7e68f3bee7e93b0b48b.svg";